import { ticketBaiService } from "@/_services";

export const ticketBai = {
  namespaced: true,
  state: {
    entity: {
      data: [],
      status: {},
    },
    register: {
      data: [],
      status: {},
    },
    delete: {
      data: [],
      status: {},
    },
    invoices: {
      data: {},
      status: {},
    },
    xml: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getConfigRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getConfigError(state, error) {
      state.entity.data = [];
      state.entity.status = {
        loading: false,
        error,
      };
    },
    getConfigSuccess(state, res) {
      state.entity.data = res;
      state.entity.status = {
        loaded: true,
      };
    },
    registerRequest(state) {
      state.register.status = {
        loading: true,
      };
    },
    registerError(state, error) {
      state.register.data = [];
      state.register.status = {
        loading: false,
        error,
      };
    },
    registerSuccess(state, res) {
      state.register.data = res;
      state.register.status = {
        loaded: true,
      };
    },
    deleteRequest(state) {
      state.delete.status = {
        loading: true,
      };
    },
    deleteError(state, error) {
      state.delete.data = [];
      state.delete.status = {
        loading: false,
        error,
      };
    },
    deleteSuccess(state, res) {
      state.delete.data = res;
      state.delete.status = {
        loaded: true,
      };
    },
  },
  actions: {
    getConfig({ commit }, id) {
      commit("getConfigRequest");
      ticketBaiService
        .getConfig(id)
        .then((res) => {
          commit("getConfigSuccess", res);
        })
        .catch((error) => {
          commit("getConfigError", error);
        });
    },
    registerConfig({ commit }, { id, body }) {
      commit("registerRequest");
      ticketBaiService
        .registerConfig(id, body)
        .then((res) => {
          commit("registerSuccess", res);
        })
        .catch((error) => {
          commit("registerError", error);
        });
    },
    deleteConfig({ commit }, id) {
      commit("deleteRequest");
      ticketBaiService
        .deleteConfig(id)
        .then((res) => {
          commit("deleteSuccess", res);
        })
        .catch((error) => {
          commit("deleteError", error);
        });
    },
  },
};
